import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { CONTRACT_TYPE_OPTIONS } from '../../../constants/contract-types';
import { PLATFORM_FEATURES } from '../../../constants/platform-features';
import usePlatformFeatures from '../../../hooks/usePlatformFeatures';
import CONTRACT_INPUT_LABEL_PROPS from './contractInputLabelProps';

const ContractTypeInput = ({ input, obj, handleInfoFunc }) => {
  const { getFeatureValue } = usePlatformFeatures();
  const allowedContractTypes = getFeatureValue(
    PLATFORM_FEATURES.ALLOWED_CONTRACT_TYPES,
    null,
  );
  const visibleOptions = useMemo(() => {
    if (!allowedContractTypes?.length) return CONTRACT_TYPE_OPTIONS;
    return CONTRACT_TYPE_OPTIONS.filter(
      (option) => allowedContractTypes.includes(option.value),
    );
  }, [allowedContractTypes]);

  return (
    <TextField
      select
      sx={input.sx}
      id={input.id}
      label={input.label}
      disabled={input.disabled || Boolean(obj.contractTypeLocked)}
      value={obj[input.id] || ''}
      onChange={(e) => handleInfoFunc(input.id, e.target.value, obj.id)}
      SelectProps={{ className: input.selectClassName }}
      InputLabelProps={CONTRACT_INPUT_LABEL_PROPS}
    >
      {visibleOptions.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

ContractTypeInput.propTypes = {
  input: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    selectClassName: PropTypes.string,
    sx: PropTypes.shape({
      width: PropTypes.string,
    }),
  }).isRequired,
  obj: PropTypes.shape({
    id: PropTypes.number,
    rut: PropTypes.string,
    mainDisabled: PropTypes.bool,
    contractType: PropTypes.string,
    contractTypeLocked: PropTypes.bool,
  }).isRequired,
  handleInfoFunc: PropTypes.func.isRequired,
};

export default ContractTypeInput;
